/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Target_LocalesInputs */

const cs_property_ai_target_locales = /** @type {(inputs: Property_Ai_Target_LocalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do jazyků`)
};

const en_property_ai_target_locales = /** @type {(inputs: Property_Ai_Target_LocalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To languages`)
};

/**
* | output |
* | --- |
* | "To languages" |
*
* @param {Property_Ai_Target_LocalesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_target_locales = /** @type {((inputs?: Property_Ai_Target_LocalesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Target_LocalesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_target_locales(inputs)
	return cs_property_ai_target_locales(inputs)
});